export default "assets/images/icons/mail-69d752c1.svg";